/**
 * Material Select creates a 'duplicate' of the select input field as a ul li. We hunt for the active by passing the id
 * of the original select element and match the active element  within the ul li
 * @param id
 * @param type
 * @returns {*|jQuery|null}
 */
export function findActiveSelectedInputTagElement(id, type) {
	return $(`#${id}`)
		.siblings('.dropdown-content.select-dropdown')
		.find(type) || null;
}

/**
 * Watches the select field for changes and returns a callback
 * @param id
 * @param {callback} cb - Called of click of element
 */
export function watchSelectedOptionChange(id,callback) {
	let _callback = callback,
		selectedTagOption = findActiveSelectedInputTagElement(id,'li');

	if (selectedTagOption === null) {
		return;
	}
	selectedTagOption.on('click', function (e) {
		_callback.call($(this));
	});
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/materialSelectVue.js